import styled from "styled-components";

export const MusicPracticeRoomDetailContainerStyled = styled.div`
  padding: 20px 20px 46px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .music_practice_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .header_layout {
      margin-bottom: 32px;
    }
    .detail_layout {
      margin-bottom: 28px;
    }
    .topic_block {
      margin-bottom: 20px;
      .title {
        margin-bottom: 20px;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      }
      .price {
        color: ${({ theme }) => theme.COLORS.BLACK_3};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
    }

    .banner_block {
      margin-bottom: 30px;
      .banner_img_wrap {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
    .description {
      margin-bottom: 30px;
      color: ${({ theme }) => theme.COLORS.GRAY_16};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
    .feature_block {
      margin-bottom: 30px;
      display: flex;
      flex-wrap: wrap;
      column-gap: 20px;
      row-gap: 10px;
      .feature_item {
        display: flex;
        align-items: center;
      }
      .feature_item_text {
        margin-left: 10px;
        color: ${({ theme }) => theme.COLORS.GRAY_18};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
    }
    .book_block {
      margin: auto;
      margin-bottom: 20px;
      max-width: 215px;
      display: flex;
      .btn_book_wrap {
        width: 215px;
      }
    }
    .button_layout {
      margin-left: 42px;
      .button1 {
        width: 215px;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 46px 20px;
    .breadcrumb_layout {
      display: none;
    }
    .music_practice_container {
      .button_layout {
        margin-left: 0px;
      }
    }
  }
`;
